import { act } from "react-dom/test-utils";
import { get } from "react-hook-form";
import { restaurantTypes, userTypes } from "../types";
import { tableTypes } from "../types";

const initialstate = {
  allRestaurants: [],
  restaurantTableTypes: [],
};

const restaurantReducer = (state = initialstate, action) => {
  const getData = () => action.payload?.data;

  const getUpdatedRestaurants = () => {
    let allres = state.allRestaurants;
    let foundRes = allres.findIndex((res) => {
      return res._id === getData().data.id;
    });
    if (foundRes > -1) {
      allres[foundRes] = getData().data;
    }

    console.log("found res", allres[foundRes]);
    return allres;
  };

  // console.log(action);
  // console.log(getData());
  switch (action.type) {
    // case restaurantTypes.CREATE_RESTAURANT_SUCCESS:
    //   return {
    //     ...state,
    //     allRestaurants: [
    //       ...state.allRestaurants,
    //       { ...action.payload.data.data, branchCount: 0, userCount: 0 },
    //     ],
    //   };

    // case restaurantTypes.UPDATE_RESTAURANT_SUCCESS:
    //   return {
    //     ...state,
    //     allRestaurants: [...getUpdatedRestaurants()],
    //   };
    case restaurantTypes.GET_ALL_RESTAURANTS_SUCCESS:
      return {
        ...state,
        allRestaurants: getData().data,
      };
    case userTypes.LOGOUT_USER:
      return { ...initialstate };

    case tableTypes.GET_ALL_RESTAURANT_TABLETYPES:
      return {
        ...state,
        restaurantTableTypes: [],
      }
    case tableTypes.GET_ALL_RESTAURANT_TABLETYPES_SUCCESS:
      return {
        ...state,
        restaurantTableTypes: getData()?.data,
      }
    default:
      return state;
  }
};

export default restaurantReducer;
